module.exports = __webpack_public_path__ + "media/images/icon-checkbox-on2-181eb053e4669fd5e31b315064899f84.svg";